import {of} from 'rxjs';
import {
  catchError,
  filter,
  map,
  mergeMap,
  switchMap,
  takeUntil,
} from 'rxjs/operators';
import {isActionOf, RootEpic} from 'typesafe-actions';

import {IResponseItem, IRxAxiosError} from '../../../shared';
import {sysSetInfo, sysSetLoaded} from '../../../store/system/actions';
import {
  clearModel,
  loadModelAsync,
  loadPlateDetailAsync,
  loadPlatesAsync,
  requestVotingAsync,
  setVotedPlate,
} from './actions';

interface IResponseItemDataRedirect {
  redirect: string;
}

export const loadInfo: RootEpic = (action$, state$, {electionApi}) =>
  action$.pipe(
    filter(isActionOf(loadModelAsync.request)),
    switchMap(() =>
      electionApi.loadModel().pipe(
        mergeMap(model =>
          of(loadModelAsync.success(model), sysSetLoaded(true))
        ),
        catchError(
          (error: IRxAxiosError<IResponseItem<IResponseItemDataRedirect>>) => {
            if (
              error.apiErrorResponse &&
              error.apiErrorResponse.error.http_code === 301 &&
              error.apiErrorResponse.data &&
              error.apiErrorResponse.data.redirect
            ) {
              window.location.href = error.apiErrorResponse.data.redirect;
            }

            if (
              error.response &&
              (error.response.status === 404 ||
                error.response.status === 400) &&
              error.apiErrorResponse
            ) {
              return of(
                loadModelAsync.failure(error.message),
                sysSetInfo({
                  code: error.apiErrorResponse.error.code,
                  message: error.apiErrorResponse.message,
                }),
                clearModel()
              );
            }
            return of(loadModelAsync.failure(error.message));
          }
        ),
        takeUntil(action$.pipe(filter(isActionOf(loadModelAsync.cancel))))
      )
    )
  );

export const loadPlateEpic: RootEpic = (action$, state$, {electionApi}) =>
  action$.pipe(
    filter(isActionOf(loadPlatesAsync.request)),
    mergeMap(action => {
      return electionApi.loadPlates().pipe(
        map(plates => loadPlatesAsync.success(plates)),
        catchError((error: IRxAxiosError) =>
          of(loadPlatesAsync.failure(error.message))
        )
      );
    })
  );

export const loadPlateDetailAsyncEpic: RootEpic = (
  action$,
  state$,
  {electionApi}
) =>
  action$.pipe(
    filter(isActionOf(loadPlateDetailAsync.request)),
    mergeMap(action => {
      return electionApi.loadPlateDetailByUuid(action.payload).pipe(
        map(data => loadPlateDetailAsync.success(data)),
        catchError((error: IRxAxiosError) =>
          of(loadPlateDetailAsync.failure(error.message))
        )
      );
    })
  );

export const voteAsyncEpic: RootEpic = (action$, state$, {electionApi}) =>
  action$.pipe(
    filter(isActionOf(requestVotingAsync.request)),
    mergeMap(action => {
      return electionApi.vote(action.payload).pipe(
        mergeMap(data => [
          setVotedPlate(action.payload.plate_uuid),
          requestVotingAsync.success(data),
        ]),
        catchError((error: IRxAxiosError) =>
          of(requestVotingAsync.failure(error.message))
        )
      );
    })
  );



// WEBPACK FOOTER //
// ./src/features/election/store/epics.ts